module.exports = __webpack_public_path__ + "img/power-off.42527ba1.svg";